// [init]
import moment from 'moment';

export default {


	namespaced: true,

	state: {
		// Listing of all transactions ( Array )
		transactionsList: [],

		// Current Transaction being manipulated ( viewed or edited ) ( Object )
		status: '',
		activeTransaction: {}
	},

	mutations: {

		// Add a transaction into transactionList
		addTransaction( state, newTransaction ) {
			state.transactionsList.push( newTransaction );
		},

		// Update transactionList with new list
		// @params: Array
		updateTransactionList( state, newList ) {
			state.transactionsList = newList.map(item => {
				item.total = item.total / 100;
				return item;
			});
		},

		// Update the current active Transaction object
		// @params: newActiveTransaction (Object)
		updateActiveTransaction( state, newActiveTransaction ) {
			state.activeTransaction = newActiveTransaction;
		},

		// Change status of transactionForm
		// @params: newStatus (String)
		updateStatus( state, newStatus ) {
			state.status = newStatus;
		},

		resetState( state ) {
			state.status = '';
			state.activeTransaction = {};
		}

	},

	actions: {

		/* 
		*  /POST transactions API
		*  Add a new transaction to the server
		*  @params: Object (transactions data)
		*  @return: Object
		*/
		addTransaction( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				const postData = {
					type: data.type,
					total: data.total * 100,
					customerID: data.customerID,
					// packageID: data.packageID,
					// jobID: data.jobID,
					// promocode: data.promocode,
					// creditsEarned: data.creditsEarned,
					// creditsGiven: data.creditsGiven,
					details: data.details
				};

				global.axios.request({
					method: 'post',
					url: '/transactions',
					validateStatus: ( status ) => { return status == 201; },
					data: postData
				})
				.then(response => {
					commit( 'addTransaction', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},
		
		/* 
		*  /GET transactions API
		*  Get all transactions from the server
		*  @return: Array
		*/
		getTransactions( { commit, state } ) {

			return new Promise (( resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/transactions',
					params: {
						trash: this.state.auth.type == 'admin' ? '*' : '0',
						from: 0,
						size: 9999999
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateTransactionList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id transactions API
		*  Get a single transaction from the server
		*  @params: identifier (String)
		*  @return: Object
		*/
		getTransactionsSingleCustomer( { commit, state }, identifier ) {

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/transactions',
					params: {
						customerID: identifier
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					commit( 'updateTransactionList', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET/:id transactions API
		*  Get a single transaction from the server
		*  @params: Array (due to vuex limitations)
		*  [0]: identifier (String)
		*  [1]: action (String: view/edit)
		*  @return: Object
		*/
		getSingleTransaction( { commit, state }, params ) {

			const identifier = params[0];
			const action = params[1];

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/transactions/' + identifier,
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					response.data.total = response.data.total / 100;
					commit( 'updateActiveTransaction', response.data );
					commit( 'updateStatus', action );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/* 
		*  /GET transactions API CSV
		*  Get all transactions from the server as a CSV
		*  (different headers)
		*  @return: Array
		*/
		getTransactionsCsv( { commit } ) {

			window.open( process.env.ENDPOINT + '/transactions/download_csv_file' );

		},

		reset( { commit, state } ) {
			commit( 'resetState' );
		},

		/* 
		*  /POST transactions API
		*  Add a new transaction to the server
		*  @params: Object (transactions data)
		*  @return: Object
		*/
		chargeCreditCard( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				const postData = {
					total: data.total * 100,
					customerID: data.customerID,
					// packageID: data.packageID,
					// jobID: data.jobID,
					// promocode: data.promocode,
					// creditsEarned: data.creditsEarned,
					// creditsGiven: data.creditsGiven,
					details: data.details
				};

				global.axios.request({
					method: 'post',
					url: '/customers/chargeCreditCard',
					validateStatus: ( status ) => { return status == 200; },
					data: postData
				})
				.then(response => {
					commit( 'addTransaction', response.data );
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

		/*
		GET statictis of Ad-hoc from Date to Date
		*/
		getAdhocStatistics( { commit, state }, data ) {

			return new Promise ( (resolve, reject ) => {

				global.axios.request({
					method: 'get',
					url: '/ad-hoc/statistics',
					params: {
						from_date: moment(data.fromDate).format('YYYY-MM-DD 00:00:00'),
						to_date: moment(data.toDate).format('YYYY-MM-DD 23:59:59'),
					},
					validateStatus: ( status ) => { return status == 200; }
				})
				.then(response => {
					resolve( response );
				})
				.catch(error => reject( error ));

			});

		},

	}
}


// WEBPACK FOOTER //
// ./src/custom/controllers/Transactions.js